import { formatDate } from "cd-eft/utils/formatDate";
import { timeSince } from "cd-eft/utils/timeSince";
import { observer } from "mobx-react";
import React, { Fragment } from "react";
import { Label, Col, Form, FormGroup, FormText, Table } from 'reactstrap';
import { AnalysisCommentsVM } from "../AnalysisComments/AnalysisCommentsVM";
import { StructureCommentsVM } from "../StructureComments/StructureCommentsVM";
import { Popup } from "cd-eft/components/common/Popup";
import { WaterwayCommentsVM } from "cd-eft/components/Design/Waterway/WDTContainer/WDTContentComp/WaterwayInput/WaterwayComments/WaterwayCommentsVM";

interface DesignCommentAddProps {
    selectId: string;
    defaultValue: any;
    onChange: any;
    addOrEdit: 'add' | 'edit';
    errorClassFunction: any;
    label: string;
    optionList: any[];
    validationArray: any;
}
interface ReadFormProps {
    vm: any;
    comment: any;
    index: number;
    workflowStep: any;
}

const DesignCommentAddComponent = (props: DesignCommentAddProps) => {
    return (
        <div>
            <Col>
                <Label className="usa-label workflowstep-label" htmlFor={props.selectId}>
                    {props.label}
                </Label>
                <div className="form-row-fixed-height">
                    <select
                        className={`usa-select ${props.errorClassFunction(props.selectId)}`}
                        name={props.selectId}
                        id={props.selectId}
                        // aria-label={props.selectId}
                        data-testid={`the-SelectOption-${props.selectId}-${props.addOrEdit}`}
                        defaultValue={props.defaultValue}
                        onChange={props.onChange}
                        required
                    >
                        <option value=""> - select - </option>
                        {props.optionList.map((e) => (
                            <option value={e.name} key={e.id}>
                                {e.name}
                            </option>
                        ))}
                    </select>
                </div>
                <span className="usa-error-message" id={`${props.selectId}-error--message`} role="alert">
                    <div>{props.validationArray[props.selectId]}</div>
                </span>
            </Col>
        </div>
    )
}
const DesignCommentReadFormComponent = (props: ReadFormProps) => {
    const { vm, comment, index, workflowStep } = props
    return (
        <Form fluid={+true}>
            <FormGroup>
                <Col>
                    <Label for="createdBy">
                        <div className="info">
                            {vm.deleteFormActive && (<div className="design-comment-checkbox">
                                <input

                                    id={'delete' + index}
                                    name='delete'
                                    aria-label={'delete' + index}
                                    type="checkbox"
                                    checked={vm.checkedState[index]}
                                    data-i={'delete' + index}
                                    onChange={
                                        (e) => vm.handleDeleteCheckBox(index)}
                                />
                            </div>
                            )}
                            <div className="workflowstep">
                                <strong>{workflowStep}</strong>
                            </div>
                            <div className="name">
                                {/* <strong>{comment.commentAuthor.split('@')[0].replace('.', ' ')}</strong> */}
                                <strong>{comment.commentAuthor.split('@')[0].replace('.', ' ')}</strong>
                            </div>
                            <div className="">
                                {`${comment.lastChangeDateUtc && timeSince(parseInt(comment.lastChangeDateUtc))
                                    }, ${formatDate(comment.lastChangeDateUtc)}`}
                            </div>
                            {comment.editStatus === 'update' && (
                                <div>{`\u00A0- Edited By ${comment.commentAuthor
                                    .split('@')[0]
                                    .replace('.', ' ')}`}</div>
                            )}
                        </div>
                    </Label>
                </Col>
                <FormText
                    className="form-text"
                    readOnly
                    id={comment.projectCommentId}
                    value={comment.projectComment}
                >
                    {comment.projectComment}
                </FormText>
            </FormGroup>
        </Form>
    )
}


interface EditFormProps {
    vm: AnalysisCommentsVM | StructureCommentsVM;
    comment: any;
    index: number;
    DesignCommentAddProps: DesignCommentAddProps;

}
const DesignCommentEditFormComponent = (props: EditFormProps) => {
    const { vm, comment, index, DesignCommentAddProps } = props;
    return (
        <Form fluid={+true}

            onSubmit={vm.handleSubmit}
        >
            <FormGroup>
                {vm.checkedState[index] && (
                    <DesignCommentAdd
                        {...DesignCommentAddProps}
                    />
                )}
                <Col>
                    <Label for="createdBy">
                        <div className="info">
                            <div className="design-comment-checkbox">
                                <input

                                    id={'edit' + index}
                                    name='edit'
                                    aria-label={'edit' + index}
                                    type="checkbox"
                                    checked={vm.checkedState[index]}
                                    data-i={'edit' + index}
                                    onChange={(e) => vm.handleCheckBox(index)}
                                />
                            </div>
                            <div className="workflowstep">
                                <strong>{vm instanceof AnalysisCommentsVM ?
                                    ((vm.checkedState[index] && (vm.editCommentForm.workflowstep.length !== 0)) ? vm.editCommentForm.workflowstep : comment.workflowStep)
                                    : ((vm.checkedState[index] && (vm.editStructureCommentForm.designTypeAndStructureName.length !== 0)) ? vm.editStructureCommentForm.designTypeAndStructureName : comment.designTypeAndStructureName)
                                }</strong>
                            </div>
                            <div className="name">
                                <strong>{comment.createdBy}</strong>
                            </div>
                            <div className="edited-by">
                                {`${comment.lastChangeDateUtc && timeSince(comment.lastChangeDateUtc)
                                    }, ${formatDate(comment.lastChangeDateUtc)}`}
                            </div>
                            {comment.editStatus === 'edited' && (
                                <div>{`\u00A0- Edited By ${comment.commentCreatedBy}`}</div>
                            )}
                        </div>
                    </Label>
                </Col>
                {!vm.checkedState[index] && (
                    <FormText
                        className="form-text"
                        readOnly
                        id={comment.projectCommentId}
                        value={comment.projectComment}
                    >
                        {comment.projectComment}
                    </FormText>
                )}
                {vm.checkedState[index] && (<div className="edit-input">
                    <textarea
                        className={`comment-textarea ${vm.errorClass('projectComment')}`}
                        id={comment.commentTypeId}
                        name="projectComment"
                        defaultValue={comment.projectComment}
                        placeholder="add comment"
                        onChange={(e) => vm.handleInputChange(e, index)}
                        rows={4}
                        wrap="soft"
                    />
                    <span className="usa-error-message" id="projectComment-error--message" role="alert">
                        <div>{vm.formValidation.formErrors['projectComment']}</div>
                    </span>
                </div>
                )}
            </FormGroup>
        </Form>
    )
}

interface DeletePopupProps {
    vm: AnalysisCommentsVM | StructureCommentsVM | WaterwayCommentsVM;
    commentList: any[];
    nameHeader: string;
}
const DesignCommentDeleteComponent = (props: DeletePopupProps) => {
    const { vm, commentList } = props
    if (vm.deletePopup) return (
        <div className="delete-popup">
            <Popup
                trigger={vm.deletePopup}
                setTrigger={vm.toggleDeletePopup}
                title="Delete Comment?"
                handleCancel={vm.cancelComment}
                cancelText="Close"
                handleOK={vm.handleDeleteComments}
                okText="Delete"
            >
                {vm.checkedState.filter(Boolean).length === 1 ?
                    <p>Are you sure you want to delete this comment?</p> :
                    <p>Are you sure you want to delete these comments?</p>
                }
                {
                    commentList.filter((comment, index) => vm.checkedState[index]).map((deleteComment, i) => {
                        return (
                            <div
                                key={'key delete -' + i}
                                className={`${vm.checkedState.filter(Boolean).length === 1
                                    ? 'single-comment-wrrapper'
                                    : 'delete-comment-wrraper'
                                    } `}
                            >
                                <Table borderless>
                                    <tbody>
                                        <tr>
                                            <th scope="row">Author</th>
                                            <td className="name capitalize">{deleteComment.commentAuthor.split('@')[0].replace('.', ' ')}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Created</th>
                                            <td>{formatDate(deleteComment.creationDateUtc)}</td>
                                        </tr>
                                        {deleteComment.editStatus === 'update' && (
                                            <>
                                                <tr>
                                                    <th scope="row">Edited by</th>
                                                    <td>{deleteComment.lastChangedBy.split('@')[0].replace('.', ' ')}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Edited on</th>
                                                    <td>{formatDate(deleteComment.lastChangeDateUtc)}</td>
                                                </tr>
                                            </>
                                        )}
                                        <tr>
                                            <th scope="row">{props.nameHeader}</th>
                                            <td>{vm instanceof AnalysisCommentsVM ? deleteComment.workflowStep : deleteComment.designTypeAndStructureName}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Comment</th>
                                            <td>{deleteComment.projectComment}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        );
                    })}
            </Popup>
        </div>
    )
    else {
        return null;
    }
}

interface IReadAndEditProps extends EditFormProps {
    readFormVarName: string;
}
export const DesignCommentReadAndEdit = observer((props: IReadAndEditProps) => {
    const { vm, comment, index, DesignCommentAddProps, readFormVarName } = props;
    return (
        <div className="comment-wrapper " key={'key activity -' + index}>
            {/********************  Read Comments Form   ********************/}
            {vm.readOnlyFormActive && (
                <DesignCommentReadForm vm={vm} comment={comment} index={index} workflowStep={comment[readFormVarName]} />
            )}
            {/********************  End of Read Comments Form   ********************/}

            {/********************  Edit Comments Form   ********************/}
            {vm.editFormActive && (
                <DesignCommentEditForm
                    vm={vm}
                    comment={comment}
                    index={index}
                    DesignCommentAddProps={DesignCommentAddProps}
                />
            )}

            {vm.editFormActive && vm.checkedState[index] && (
                <div className="d-flex justify-content-end usa-buttons">
                    <button className="usa-button usa-button--outline" onClick={vm.cancelEditComment}>
                        Close
                    </button>
                    <button className="usa-button" onClick={vm.saveEditComment}>
                        Save
                    </button>
                </div>
            )}
        </div>
    );
})

interface DesignCommentCloseButtonsProps {
    vm: AnalysisCommentsVM | StructureCommentsVM;
}
export const DesignCommentCloseButtons = observer((props: DesignCommentCloseButtonsProps) => {
    return (
        <Fragment>
            {props.vm.editFormActive && props.vm.cancelFormBtnActive && (
                <div className="d-flex justify-content-end usa-buttons">
                    <button className="usa-button usa-button--outline" onClick={props.vm.cancelComment}>
                        Close
                    </button>
                </div>
            )}

            {props.vm.deleteFormActive && props.vm.checkedState.some(Boolean) && (
                <div className="d-flex justify-content-end usa-buttons">
                    <button className="usa-button usa-button--outline" onClick={props.vm.cancelComment}>
                        Close
                    </button>
                    <button className="usa-button" onClick={props.vm.toggleDeletePopup}>
                        Delete
                    </button>
                </div>
            )}
        </Fragment>
    )
})


export const DesignCommentAdd = observer(DesignCommentAddComponent);
export const DesignCommentReadForm = observer(DesignCommentReadFormComponent);
export const DesignCommentEditForm = observer(DesignCommentEditFormComponent);
export const DesignCommentDeletePopup = observer(DesignCommentDeleteComponent);